import urljoin from "url-join";

export const EVENTTYPE_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "eventtype"
);
export const PERSONAL_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "personal"
);
export const CLIENTS_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "client"
);
export const GENERAL_REQUESTS_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "generalRequest"
);
export const NOTIFICATION_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "notification"
);
export const REQUEST_TYPE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "requestType"
);

export const REPORT_TYPE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "report_settings"
);

export const FINISH_CONCEPT_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "finishConcept"
);

export const REQUEST_GENERAL_NOTIFICATION = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "generalNotification"
);

export const CONTRACTOR_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "contractor"
);
export const LOCATION_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "location"
);
export const MEASUREMENTUNIT_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "measurementunit"
);

export const OPERATIONAL_AREA_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "operationalarea"
);

export const SUPPLY_API = urljoin(process.env.REACT_APP_API_BASE_URL, "supply");
export const SUPPLY_USAGE_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "supply-usage"
);
export const TEAMS_API = urljoin(process.env.REACT_APP_API_BASE_URL, "team");
export const EVENTS_API = urljoin(process.env.REACT_APP_API_BASE_URL, "event");
export const COMPANY_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "company"
);
export const DEVICE_SETUP_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "device-setup"
);
export const STATUS_CHANGE_SETUP_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "statuschangesetup"
);
export const STATUS_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "event",
  "status"
);
export const NEWNESS_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "newness"
);
export const ADDITIONAL_NEWNESS_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "additionalnewness"
);
export const QUOTATION_SETUP_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "quotationSetup"
);
export const QUOTATION_REQUEST_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "quotationRequest"
);
export const WORKFLOW_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "workflow"
);
export const FORM_FIELDS_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "formfield"
);
export const DYNAMIC_FORM_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "dynamicform"
);
export const VEHICLE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "vehicle"
);

export const VEHICLE_TYPE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "vehicletype"
);

export const EVIDENCE_TEMPLATE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "evidenceTemplate"
);

export const RESOLUTION_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "resolution"
);

export const AUTH_ENDPOINT = urljoin(
  process.env.REACT_APP_API_AUTH_BASE_URL,
  "user"
);

export const PROFILE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_AUTH_BASE_URL,
  "role"
);

export const POSITION_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "position"
);

export const DYNAMIC_FORM_FIELD_VALUE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "dynamic-form-field-value"
);

export const PROCEEDING_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "proceeding"
);

export const EVIDENCE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "evidence"
);

export const WAREHOUSE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "warehouse"
);

export const CLIENT_TYPE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "clientType"
);

export const ADDITIONAL_COST_TYPE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "additionalCostType"
);

export const INVENTORY_MOVEMENT_TYPE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "inventory_movement_type"
);

export const PROVIDER_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "provider"
);

export const INVENTORY_MOVEMENT_HEADER_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "inventory_movement"
);

export const DAILY_ROUTE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "dailyRoute"
);

export const ADDITIONAL_COST_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "additionalCost"
);
export const ADDITIONAL_COST_API = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "additional-cost"
);

export const PAYMENT_TYPE_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "paymentType"
);

export const PAYMENT_TO_TECHNICIAN_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "paymentToTechnician"
);

export const PREORDER_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "PreOrder"
);

export const BILL_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "bill"
);

export const SETTLEMENT_ENDPOINT = urljoin(
  process.env.REACT_APP_API_BASE_URL,
  "settlement"
);
